module.exports = __webpack_public_path__ + "img/cir-inWork.b772edef.svg";